import Common from "./Common.js";
import Nav from "./widgets/Nav.js";

const app = async () => {
    Nav.init();
    Common.init();
};

document.addEventListener('DOMContentLoaded', app);
